import React from "react";
import Select from "react-select";
import BlockUi from "@availity/block-ui";

const Filters = (props) => {

  const renderMinField = (filter) => {
    return (
      <div className="input-group range-group" key={`min_${filter.key}`}>
        <div className="input-group-text">min</div>
        <input
          className="form-control min-field"
          name={`${filter.key}_min`}
          id={`filter_field_${filter.key}`}
          defaultValue={filter.minValue}
          placeholder={filter.minimum}
          onBlur={e => {
            if (filter.minValue != e.currentTarget.value) {
              props.onMinInputChange(filter.key, e.currentTarget.value);
            }
          }}
          onKeyPress={e => {
            if (e.key == "Enter" && filter.minValue != e.currentTarget.value) {
              props.onMinInputChange(filter.key, e.currentTarget.value);
            }
          }}
        />
      </div>
    );
  }

  const renderMaxField = (filter) => {
    return (
      <div className="input-group range-group" key={`max_${filter.key}`}>
        <div className="input-group-text">max</div>
        <input
          className="form-control max-field"
          name={`${filter.key}_max`}
          id={`filter_field_${filter.key}`}
          defaultValue={filter.maxValue}
          placeholder={filter.maximum}
          onBlur={e => {
            if (filter.maxValue != e.currentTarget.value) {
              props.onMaxInputChange(filter.key, e.currentTarget.value);
            }
          }}
          onKeyPress={e => {
            if (e.key == "Enter" && filter.maxValue != e.currentTarget.value) {
              props.onMaxInputChange(filter.key, e.currentTarget.value);
            }
          }}
        />
      </div>
    );
  }

  const renderInterval = (filter) => {
    return [renderMinField(filter), renderMaxField(filter)];
  }

  const renderSelect = (filter) => {
    const { selectPlaceholder, key, value, options } = filter;
    return (
      <Select.Creatable
        placeholder={selectPlaceholder}
        name={`${key}[]`}
        id={`filter_field_${key}`}
        multi={true}
        removeSelected={false}
        value={value}
        options={[...options]}
        onChange={selectedOptions => {
          props.onSelectChange(key, selectedOptions);
        }}
        promptTextCreator={label => {
          return `Filter by ${label}`;
        }}
        newOptionCreator={option => {
          const newOption = {};
          newOption[option.valueKey] = `custom_value__${option.label}`;
          newOption[option.labelKey] = option.label;
          newOption.className = 'Select-create-option-placeholder';
          return newOption;
        }}
      />
    );
  }

  const renderFilter = (filter) => {
    if (filter.showAsInterval) {
      return renderInterval(filter);
    } else if (filter.showAsMinText) {
      return renderMinField(filter);
    } else if (filter.showAsMaxText) {
      return renderMaxField(filter);
    } else {
      return renderSelect(filter);
    }
  }

  const {
    filters,
    blockingUI,
    translations,
    onResetFiltersClick
  } = props;

  return (
    <div className="filters-component">
      <BlockUi tag="div" blocking={blockingUI}>
        <form>
          {filters.map(filter => (
            <div className="mb-3" key={`filter_${filter.key}`}>
              <label
                className="form-label fw-bold"
                htmlFor={`filter_${filter.key}`}
              >
                {filter.name}
              </label>
              {renderFilter(filter)}
            </div>
          ))}
        </form>
        <div className="text-end">
          <a href="#" onClick={onResetFiltersClick}>
            <i className="fa fa-refresh" /> {translations.reset_filters}
          </a>
        </div>
      </BlockUi>
    </div>
  );
}

export default Filters;